import React from "react";
type FeedbackProps = React.PropsWithChildren<{}>;
function Feedback(props: FeedbackProps) {
	return <div className="h-full">{props.children}</div>;
}

export default Feedback;